<template>
  <div v-if="hasAnyCard" class="sm:pb-5 home__info pl-4 sm:pl-0">
    <swiper
      :slides-per-view="4.4"
      :space-between="20"
      :pagination="true"
      :modules="modules"
      :breakpoints="{ 0: { slidesPerView: 1.4, spaceBetween: 10 }, 450: { slidesPerView: 1.6, spaceBetween: 10 }, 600: { slidesPerView: 1.8 }, 900: { slidesPerView: 3, spaceBetween: 10 }, 1100: { slidesPerView: 4, spaceBetween: 20 } }"
      class="pb-10"
    >
      <swiper-slide v-if="section.settings.showMinimumOrder">
        <div class="border p-4 flex items-center gap-4 home__info__card">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M19.24 5.58H18.84L15.46 2.2C15.19 1.93 14.75 1.93 14.47 2.2C14.2 2.47 14.2 2.91 14.47 3.19L16.86 5.58H7.14L9.53 3.19C9.8 2.92 9.8 2.48 9.53 2.2C9.26 1.93 8.82 1.93 8.54 2.2L5.17 5.58H4.77C3.87 5.58 2 5.58 2 8.14C2 9.11 2.2 9.75 2.62 10.17C2.86 10.42 3.15 10.55 3.46 10.62C3.75 10.69 4.06 10.7 4.36 10.7H19.64C19.95 10.7 20.24 10.68 20.52 10.62C21.36 10.42 22 9.82 22 8.14C22 5.58 20.13 5.58 19.24 5.58Z" fill="currentColor"/>
            <path d="M19.0502 12H4.87016C4.25016 12 3.78016 12.55 3.88016 13.16L4.72016 18.3C5.00015 20.02 5.75015 22 9.08015 22H14.6902C18.0602 22 18.6602 20.31 19.0202 18.42L20.0302 13.19C20.1502 12.57 19.6802 12 19.0502 12ZM12.0002 19.5C9.66016 19.5 7.75016 17.59 7.75016 15.25C7.75016 14.84 8.09016 14.5 8.50015 14.5C8.91015 14.5 9.25015 14.84 9.25015 15.25C9.25015 16.77 10.4802 18 12.0002 18C13.5202 18 14.7502 16.77 14.7502 15.25C14.7502 14.84 15.0902 14.5 15.5002 14.5C15.9102 14.5 16.2502 14.84 16.2502 15.25C16.2502 17.59 14.3402 19.5 12.0002 19.5Z" fill="currentColor"/>
          </svg>
          <div>
            <p class="font-medium text-sm md:text-md">Pedido mínimo</p>
            <h6 v-if="restaurant.restaurantConfig?.minimumOrderAmount != null" class="font-bold text-xs md:text-sm text-success">{{ formatBRL(restaurant.restaurantConfig?.minimumOrderAmount) }}</h6>
            <h6 v-else class="sf-skeleton w-15 h-4 animate-pulse"></h6>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide v-if="section.settings.showHours">
        <div class="border p-4 flex items-center gap-4 home__info__card">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-clock" viewBox="0 0 16 16"> <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"/> <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z"/> </svg>
          <div>
            <p class="font-medium text-sm md:text-md">{{ daysFormat[new Date().getDay()] }}</p>
            <h6 class="sf-skeleton w-15 h-4 animate-pulse" v-if="!restaurant.id"></h6>
            <h6 v-if="todaySchedule" class="text-xs text-success font-bold md:text-sm pr-10">{{ todaySchedule.openingTime.slice(0, 5) }}h às {{ todaySchedule.closingTime.slice(0, 5) }}h</h6>
            <p class="text-xs md:text-sm text-red-500 font-medium pr-10" v-if="!todaySchedule && restaurant.id">Fechado</p>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide v-if="section.settings.showWhatsapp && restaurant.restaurantConfig?.whatsapp">
        <div class="border p-4 flex items-center gap-4 home__info__card">
          <svg viewBox="0 0 24 24" role="presentation" style="width: 1.65rem; height: 1.65rem;"><path d="M6.62,10.79C8.06,13.62 10.38,15.94 13.21,17.38L15.41,15.18C15.69,14.9 16.08,14.82 16.43,14.93C17.55,15.3 18.75,15.5 20,15.5A1,1 0 0,1 21,16.5V20A1,1 0 0,1 20,21A17,17 0 0,1 3,4A1,1 0 0,1 4,3H7.5A1,1 0 0,1 8.5,4C8.5,5.25 8.7,6.45 9.07,7.57C9.18,7.92 9.1,8.31 8.82,8.59L6.62,10.79Z" style="fill: currentcolor;"></path></svg>
          <div>
            <p class="font-medium text-sm md:text-md">Whatsapp</p>
            <h6 class="font-bold text-xs md:text-sm text-success">{{ restaurant.restaurantConfig?.whatsapp }}</h6>
          </div>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Pagination, FreeMode } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'
import 'swiper/css/pagination'
import { restaurant } from '@/global/state/GlobalState'
import { InfoSection } from '@/global/state/StorefrontState'
import { formatBRL } from '../storefrontUtils'

/* global defineProps */
const props = defineProps<{ section: InfoSection }>()

const modules = [Pagination, FreeMode]
const daysFormat: Record<number, string> = {
  0: 'Domingo',
  1: 'Segunda-feira',
  2: 'Terça-feira',
  3: 'Quarta-feira',
  4: 'Quinta-feira',
  5: 'Sexta-feira',
  6: 'Sábado'
}

const todaySchedule = computed(() => restaurant.value.schedules?.find((s: any) => s.day == new Date().getDay()))

const hasAnyCard = computed(() => {
  const s = props.section.settings
  return s.showMinimumOrder || s.showHours || (s.showWhatsapp && !!restaurant.value.restaurantConfig?.whatsapp)
})
</script>

<style>
.home__info__card {
  width: 100%;
  border-radius: var(--sf-radius);
  border-color: var(--sf-border);
  background: var(--sf-card-bg);
  color: var(--sf-text);
}
</style>
